module.exports = __webpack_public_path__ + "img/vertical_4_4_7016.44786228.png";